import { render, staticRenderFns } from "./ArticlesList.vue?vue&type=template&id=abf32c4a&scoped=true"
import script from "./ArticlesList.vue?vue&type=script&lang=js"
export * from "./ArticlesList.vue?vue&type=script&lang=js"
import style0 from "./ArticlesList.vue?vue&type=style&index=0&id=abf32c4a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abf32c4a",
  null
  
)

export default component.exports